import React from 'react';
import strings from 'owa-strings/owa-mini-strings';
import styles from './MailListItem.scss';
import { format } from 'owa-strings/utilities/format';
import { getNameAndEmailForSender } from 'mini-mail-common/lib/utils/getNameAndEmailForSender';
import { MultiSelectCheckbox } from './MultiSelectCheckbox';
import { PersonaControl, type PersonaSize } from 'owa-persona';
import type SingleRecipientType from 'owa-service/lib/contract/SingleRecipientType';
import type { MultiSelectCheckboxProps } from './MultiSelectCheckbox';

export interface PersonaCheckboxProps extends MultiSelectCheckboxProps {
    isInCheckedMode: boolean;
    lastSender: SingleRecipientType;
    rowId: string;
    onMultiSelect: (rowId: string) => void;
}

const PersonaCheckbox = (props: PersonaCheckboxProps) => {
    const { rowId, isInCheckedMode, lastSender, onMultiSelect } = props;

    const onClickPersona = React.useCallback(() => {
        onMultiSelect(rowId);
        /* eslint-disable-next-line react-hooks/exhaustive-deps --
         * See aka.ms/mini-lint-errors
         *	> React Hook React.useCallback has a missing dependency: 'onMultiSelect'. Either include it or remove the dependency array. */
    }, [rowId]);

    let personaComponent: JSX.Element = null;
    let checkboxComponent: JSX.Element = null;

    if (isInCheckedMode) {
        checkboxComponent = <MultiSelectCheckbox isSelected={props.isSelected} />;
    }

    const lastSenderMailbox = lastSender?.Mailbox;
    const displaySelfPersona = !(lastSenderMailbox?.Name || lastSenderMailbox?.EmailAddress);
    const { name, emailAddress } = getNameAndEmailForSender(lastSender, displaySelfPersona);

    personaComponent = (
        <div className={isInCheckedMode ? styles['mailListItem--hidePersona'] : null}>
            <PersonaControl
                className={styles['mailListItem--persona']}
                name={name}
                onClickPersona={onClickPersona}
                emailAddress={emailAddress}
                size={3}
                ariaLabel={format(strings.messageHeaderContactCardAriaLabel, name)}
            />
        </div>
    );

    return (
        <div className={styles['mailListItem--leftContainer']} aria-hidden>
            {personaComponent}
            {checkboxComponent}
        </div>
    );
};

export default PersonaCheckbox;
